/**
 * AlertModal Component
 * Replacement for browser alert() with custom styling
 */

import Modal from './Modal'
import { AlertCircle } from 'lucide-react'

export interface AlertModalProps {
  isOpen: boolean
  onClose: () => void
  title?: string
  message: string
  type?: 'info' | 'warning' | 'error' | 'success'
}

export function AlertModal({
  isOpen,
  onClose,
  title,
  message,
  type = 'info',
}: AlertModalProps) {
  const getIcon = () => {
    switch (type) {
      case 'error':
        return <AlertCircle size={24} color="#EF4444" />
      case 'warning':
        return <AlertCircle size={24} color="#F59E0B" />
      case 'success':
        return <AlertCircle size={24} color="#10B981" />
      default:
        return <AlertCircle size={24} color="#3B82F6" />
    }
  }

  const getDefaultTitle = () => {
    switch (type) {
      case 'error':
        return 'Error'
      case 'warning':
        return 'Warning'
      case 'success':
        return 'Success'
      default:
        return 'Information'
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title || getDefaultTitle()}
      maxWidth={400}
      closeOnBackdropClick={true}
      closeOnEscape={true}
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <button
            className="modal-button modal-button-primary"
            onClick={onClose}
            autoFocus
          >
            OK
          </button>
        </div>
      }
    >
      <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
        {getIcon()}
        <p style={{ margin: 0, flex: 1 }}>{message}</p>
      </div>
    </Modal>
  )
}
